import { Component, Input } from '@angular/core';

import { getFilterSolid, getPathConfig } from '../power-state.utils';

const PATH_SOLAR_TO_GRID = 'M 50 25 Q 50 50 25 75';
const PATH_SOLAR_TO_HOME = 'M 50 25 Q 50 50 75 75';
const PATH_GRID_TO_HOME = 'M 25 75 Q 50 50 75 75';

@Component({
  selector: 'app-power-state-mode-one',
  templateUrl: './power-state-mode-one.component.html',
  styleUrls: ['./power-state-mode-one.component.scss'],
})
export class PowerStateModeOneComponent {

  @Input() bgTextColor = 'white';
  @Input() unitLabel = 'Unit';
  @Input() unitSymbol = 'W';
  @Input() valuePrecision = 0;
  @Input() duration = 3;
  @Input() fontSize = 4;
  @Input() showPowerFlow?: boolean;
  @Input() fromGridToHome?: number;
  @Input() fromSolarToGrid?: number;
  @Input() fromSolarToHome?: number;

  readonly PATH_SOLAR_TO_GRID = PATH_SOLAR_TO_GRID;
  readonly PATH_SOLAR_TO_HOME = PATH_SOLAR_TO_HOME;
  readonly PATH_GRID_TO_HOME = PATH_GRID_TO_HOME;

  readonly getFilterSolid = (color = this.bgTextColor) => getFilterSolid(color);

  readonly getPathConfig = (params: object, duration = this.duration) =>
    getPathConfig(params, duration, { reverse: false });
}
